import { render, staticRenderFns } from "./projectIndex.vue?vue&type=template&id=83c77238&scoped=true"
import script from "./projectIndex.vue?vue&type=script&lang=js"
export * from "./projectIndex.vue?vue&type=script&lang=js"
import style0 from "./projectIndex.vue?vue&type=style&index=0&id=83c77238&prod&lang=css"
import style1 from "./projectIndex.vue?vue&type=style&index=1&id=83c77238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c77238",
  null
  
)

export default component.exports